var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"},on:{"after-enter":_vm.showMenuContent,"before-leave":_vm.hideMenuContent,"after-leave":_vm.emitTransitionFinished}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"sliding-side-menu",attrs:{"data-test-id":"sliding-side-menu"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }